module.exports = __webpack_public_path__ + "static/img/s54.81a7e19b.png";